const BaseModule = require('../../90_utils/base/BaseModule');

class AnimationController extends BaseModule {

	constructor(el, params) {

		super(el);

		CustomEase.create('fade', 'M0,0 C0.384,0.104 0.242,0.942 1,1');
		CustomEase.create("fadeOut", "M0,0 C0.242,0.132 0.65,0.66 1,1")
		CustomEase.create('longFade', 'M0,0 C0.488,0.128 0.242,0.942 1,1');
		CustomEase.create("progressSlide", "M0,0 C0.074,0.138 0.048,0.682 0.238,0.83 0.428,0.978 0.816,0.995 1,1");
		CustomEase.create("sectionFade", "M0,0 C0.149,0 0.279,0.253 0.436,0.518 0.54,0.694 0.698,1 1,1");
		CustomEase.create("scrollEase", "M0,0 C0.124,0.036 0.192,0.094 0.242,0.188 0.292,0.283 0.423,0.772 0.486,0.866 0.561,0.977 0.704,1 1,1");
	}

	//

	_domReady(){ }

	_addListeners(){ }
	_removeListeners(){ }

	// show / hide

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }
}

module.exports = AnimationController;
